import { CODEC, DRM_TYPE, VIDEO_TYPE } from '../enums';
import { uaTool, videoTool } from '../util';
/**
 * 结合浏览器环境能力和视频Meta信息判断内核类型是否可用，也控制在某些环境是否启用该内核，未引用内核也无需加载
 */
var kernelAvailable = {
    isHlsjsAvailable: function (metadata) {
        if (!metadata) {
            return false;
        }
        // 非hls格式无法播放，如果加密内容是Fairplay目前只能使用原生内核所以HLSjs也无法播放
        if (metadata.videoType !== VIDEO_TYPE.HLS || metadata.drmType === DRM_TYPE.FAIRPLAY) {
            return false;
        }
        // 如果是视频265编码，必须检查浏览器是否支持HEVC
        if (metadata.vcodec === CODEC.H265 && !videoTool.supportHevc()) {
            return false;
        }
        // 如果是视频AV1编码，必须检查浏览器是否支持AV1
        if (metadata.vcodec === CODEC.AV1 && !videoTool.supportAV1()) {
            return false;
        }
        // 如果环境是否支持MSE就可以使用hls
        return videoTool.supportMSE();
    },
    /**
     * 判断当前视频在Flvjs是否可播
     * @param metadata 视频播放数据信息
     * @returns 是否可播
     */
    isFlvjsAvailable: function (metadata) {
        // 移动端不启用flv内核，尚无该场景使用需求，且没有验证过兼容性
        if (!metadata || uaTool.mobile) {
            return false;
        }
        // 非flv格式、加密内容播放均无法播放
        if (metadata.videoType !== VIDEO_TYPE.FLV || metadata.drmType !== DRM_TYPE.NONE) {
            return false;
        }
        // 如果环境是否支持MSE就可以使用flv
        return videoTool.supportMSE();
    },
    /**
     * 判断当前视频在Demux2fmp4内核是否可播
     * @param metadata 视频播放数据信息
     * @returns 是否可播
     */
    isDemux2fmp4Available: function (metadata) {
        if (!metadata) {
            return false;
        }
        // 只能播放MP4和MOV格式视频
        if (metadata.videoType !== VIDEO_TYPE.MP4 && metadata.videoType !== VIDEO_TYPE.MOV) {
            return false;
        }
        // 如果是视频265编码，必须检查浏览器是否支持HEVC
        if (metadata.vcodec !== undefined && metadata.vcodec !== CODEC.H264) {
            return false;
        }
        // 如果环境是否支持MSE就可以使用2fmp4内核
        return videoTool.supportMSE();
    },
    /**
     * 判断当前视频在Webrtcplayer内核是否可播
     * @param metadata 视频播放数据信息
     * @returns 是否可播
     */
    isWebrtcplayerAvailable: function (metadata) {
        if (!metadata) {
            return false;
        }
        // 只能Webrtc协议能播放
        if (metadata.videoType !== VIDEO_TYPE.WEBRTC) {
            return false;
        }
        return videoTool.isWebRTCSupported();
    },
    /**
     * 判断当前视频在Wasmplayer是否可播
     * @param metadata 视频播放信息
     * @returns 是否可播
     */
    isWasmplayerAvailble: function (metadata) {
        // 移动端不能启用WASM，尚未验证兼容性
        if (!metadata || uaTool.mobile) {
            return false;
        }
        // WASM理论上能播放所有格式，所以无需判断videoType
        return videoTool.isWasmKernelSupported();
    },
    /**
     *判断当前视频在Electron环境是否可播，原则上Electron能播放所有格式，所以判断环境即可
     * @param metadata
     */
    isElectronPlayerAailble: function () {
        return (/electron\//i).test(navigator.userAgent);
    },
};
export default kernelAvailable;
